import React, { useCallback } from "react";
import Typography from "@material-ui/core/Typography";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import clsx from "clsx";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import SecurityIcon from "@material-ui/icons/Security";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import Paper from "@material-ui/core/Paper";
import { Redirect } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import ListIcon from "@material-ui/icons/List";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Divider from "@material-ui/core/Divider";
import Chip from "@material-ui/core/Chip";
import AddIcon from "@material-ui/icons/Add";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import swal from "sweetalert";
import AddRole from "../components/AddRole/AddRole";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { ChevronLeft, ChevronRight, PermIdentity } from "@material-ui/icons";
import MerchantUsers from "../components/MerchantUsers/MerchantUsers";
import { _get, _post } from "../Api";
import AuthorizationWrapper from "../components/AuthorizationWrapper";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));

const fetchData = (page, perPage, search, callback) => {
  _get("/nova/permissions/merchant?number_per_page=" + perPage + "&page=" + page + "&search=" + search)
    .then((res) => {
      let result = res.data;

      _get("/nova/permissions/user?number_per_page=" + perPage + "&page=" + page)
        .then((userPermissions) => {
          callback({ merchantData: result, userData: userPermissions.data });
        })
        .catch(() => {
          swal({
            title: "Oops!",
            text: "Something went wrong.",
            icon: "error",
          });
        });
    })
    .catch(() => {
      swal({
        title: "Oops!",
        text: "Something went wrong.",
        icon: "error",
      });

      console.log();
    });
};

export default function Permissions() {
  const classes = useStyles();
  const [open] = React.useState(false);
  const [logout, setLogout] = React.useState(false);
  const [value, setValue] = React.useState("one");
  const [loading, setLoading] = React.useState(true);
  const [rows, setRows] = React.useState([]);
  const [searchValue, setSearchValue] = React.useState("");
  const [filteredRows, setFilteredRows] = React.useState([]);
  const [expanded, setExpanded] = React.useState(false);
  const [, updateState] = React.useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const [users, setUsers] = React.useState([]);
  const [addRoleDialog, setAddRoleDialog] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [page, setPage] = React.useState(0);
  const [perPage, setPerPage] = React.useState(10);

  const fetchNextPage = () => {
    setPage(page + 1);
    setLoading(true);
  };

  const fetchPreviousPage = () => {
    if (page > 0) {
      setPage(page - 1);
      setLoading(true);
    }
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const logOut = () => {
    localStorage.removeItem("access_token");
    setLogout(true);
  };

  const deleteRole = (roleIndex, userIndex) => {
    _post("/nova/permissions/user/" + users[userIndex].id + "/role/" + users[userIndex].roles[roleIndex].id, {
      remove: true,
    })
      .then(() => {
        let temp = users;
        temp[userIndex].roles.splice(roleIndex, 1);
        setUsers(temp);
        forceUpdate();
      })
      .catch(() => {
        swal({
          title: "Oops!",
          text: "Something went wrong.",
          icon: "error",
        });
      });
  };

  if (logout === true) {
    return <Redirect to="/login" />;
  }

  if (loading) {
    fetchData(page, perPage, "", function (result) {
      setLoading(false);
      setRows(result.merchantData);
      setFilteredRows(result.merchantData);
      setUsers(result.userData);
      forceUpdate();
    });
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  const handleEmptySearchVal = () => {
    setSearchValue("");
    setFilteredRows(rows);
    setPage(0);
  };

  const handleSearch = (event) => {
    event.stopPropagation();
    setPage(0);
    setSearchValue(event.target.value);

    fetchData(page, perPage, event.target.value, function (result) {
      setRows(result.merchantData);
      setFilteredRows(result.merchantData);
      setUsers(result.userData);
    });

    // let temp = rows.filter((row) => {
    //     if (row.merchant_name) {
    //         return row.merchant_name.toLowerCase().includes(event.target.value.toLowerCase())
    //     }
    // });

    // setFilteredRows(temp)
  };

  const handleItemsPerPage = (event) => {
    setPage(0);
    setPerPage(event.target.value);
    setLoading(true);
  };

  const addRole = (role) => {
    if (!selectedUser.roles.includes(role)) {
      _post("/nova/permissions/user/" + selectedUser.id + "/role/" + role.id, {
        remove: false,
      })
        .then(() => {
          selectedUser.roles.push(role);
          setUsers([...users]);
          setAddRoleDialog(false);
        })
        .catch(() => {
          swal({
            title: "Oops!",
            text: "Something went wrong.",
            icon: "error",
          });
        });
    }
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleRoleDialog = (user) => {
    setAddRoleDialog(true);
    setSelectedUser(user);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`wrapped-tabpanel-${index}`}
        aria-labelledby={`wrapped-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </Typography>
    );
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <Toolbar className={classes.toolbar}>
          <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
            MynOber Cloud - User management
          </Typography>

          <IconButton color="inherit" title={"Locatie Selecteren"} onClick={() => (window.location = "/select")}>
            <ListIcon />
          </IconButton>

          <IconButton color="inherit" onClick={logOut} title={"Uitloggen"}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Paper style={{ margin: 40, border: "solid 1px grey" }} elevation={0}>
          <Tabs centered value={value} onChange={handleTabChange}>
            <Tab value="one" label="Users" />
            <Tab value="two" label="Merchants" />
            {/*<Tab value='three' label='Manage profiles'/>*/}
          </Tabs>

          <TabPanel value={value} index="one">
            <List>
              <ListItem>
                <ListItemText inset>
                  <Typography variant="h6">Email</Typography>
                </ListItemText>
              </ListItem>
              <Divider />
              {users && users.length > 0
                ? users.map((user, j) => {
                    return (
                      <ListItem key={user.email}>
                        <Grid container direction="row">
                          <Grid item container direction="row" xs={4}>
                            {
                              <AuthorizationWrapper
                                permission={"impersonate"}
                                child={
                                  <IconButton
                                    onClick={() => {
                                      _post(
                                        "/nova/api/impersonate",
                                        { impersonate_user_id: user.id },
                                        "application/json"
                                      )
                                        .then(function (response) {
                                          //handle success
                                          let token = response.data.data.access_token;
                                          let roles = [];
                                          for (let i in response.data.data.roles) {
                                            roles.push(response.data.data.roles[i].name);
                                          }
                                          sessionStorage.setItem("roles", JSON.stringify(roles));
                                          localStorage.setItem("access_token", token);
                                          window.location = "/";
                                        })
                                        .catch(() => {});
                                    }}
                                  >
                                    <PermIdentity />
                                  </IconButton>
                                }
                              />
                            }
                            <ListItemIcon style={{ marginTop: 5 }}>
                              <AccountCircleIcon />
                            </ListItemIcon>
                            <ListItemText>{user.email}</ListItemText>
                          </Grid>
                          <Grid item container direction="row" xs={8}>
                            {user.roles.map((role, i) => {
                              return (
                                <Chip
                                  key={i}
                                  onDelete={() => deleteRole(i, j)}
                                  icon={<SecurityIcon />}
                                  style={{ marginLeft: 2 }}
                                  color={["admin", "superadmin"].includes(role.name) ? "secondary" : "primary"}
                                  label={role.name}
                                />
                              );
                            })}
                            <Chip
                              onClick={() => handleRoleDialog(user)}
                              icon={<AddIcon />}
                              clickable
                              style={{ marginLeft: 20 }}
                              label="Rol toevoegen"
                            />
                          </Grid>
                        </Grid>
                      </ListItem>
                    );
                  })
                : null}
            </List>
          </TabPanel>
          <Typography
            component="div"
            role="tabpanel"
            hidden={value !== "two"}
            id={`wrapped-tabpanel-${"two"}`}
            aria-labelledby={`wrapped-tab-${"two"}`}
          >
            {value === "two" && (
              <Box p={3}>
                <TextField
                  id="12123234q"
                  key={"blabla key"}
                  value={searchValue}
                  onChange={handleSearch}
                  size="small"
                  label="Search"
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <ClearIcon
                          style={{
                            visibility: searchValue.length > 0 ? "visible" : "hidden",
                          }}
                          onClick={handleEmptySearchVal}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
                <List dense>
                  {filteredRows.map((merchant) => {
                    return (
                      <ListItem key={merchant.id} style={{ borderBottom: "1px solid black" }}>
                        <Accordion
                          expanded={expanded === "panel" + merchant.merchant_name && merchant.merchant_name}
                          onChange={handleChange("panel" + merchant.merchant_name)}
                          variant="outlined"
                          style={{ borderColor: "white", margin: 0 }}
                        >
                          <AccordionSummary>{merchant.merchant_name}</AccordionSummary>
                          <AccordionDetails>
                            <MerchantUsers key={merchant.id} merchant={merchant} />
                          </AccordionDetails>
                        </Accordion>
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
            )}
          </Typography>
        </Paper>
        <div style={{ visibility: value === "three" ? "hidden" : "visible" }}>
          <Paper variant="outlined" style={{ height: "4em" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justify: "space-around",
              }}
            >
              <div
                style={{
                  margin: "0 auto",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Typography style={{ marginTop: "15px", marginRight: "40px" }}>Page: {page + 1}</Typography>
                <Typography style={{ marginTop: "15px", marginRight: "10px" }}>Items per page: </Typography>
                <Select
                  onChange={handleItemsPerPage}
                  value={perPage}
                  variant="outlined"
                  style={{
                    height: "2em",
                    marginTop: "12px",
                    marginRight: "10px",
                  }}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>

                <IconButton onClick={fetchPreviousPage} style={{ marginTop: "5px" }}>
                  <ChevronLeft />
                </IconButton>
                <IconButton onClick={fetchNextPage} style={{ marginTop: "5px" }}>
                  <ChevronRight />
                </IconButton>
              </div>
            </div>
          </Paper>
        </div>
      </main>

      <div>
        <Dialog open={addRoleDialog} onClose={() => setAddRoleDialog(false)}>
          <DialogTitle>Add role</DialogTitle>
          <AddRole user={selectedUser} onCheck={addRole} />
        </Dialog>
      </div>
    </div>
  );
}
